import {
  FETCH_MIPS_REPORT,
  FETCH_MIPS_REPORT_SUCCESS,
  FETCH_MIPS_REPORT_ERROR,
} from './mips.types'

const INITIAL_STATE = {
  loading: false,
  error: null,
  mipsData: null,
}

const mipsReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MIPS_REPORT:
      return { ...state, loading: true, error: null }
    case FETCH_MIPS_REPORT_SUCCESS:
      return { ...state, loading: false, mipsData: action.payload }
    case FETCH_MIPS_REPORT_ERROR:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default mipsReportReducer
